// extracted by mini-css-extract-plugin
module.exports = {"card":"NumberWithText_card__nfcPS","number":"NumberWithText_number__JlLII","text":"NumberWithText_text__084iP"};